import React from 'react'

const LoadingState = ({ label = 'Loading workspace' }) => (
  <div className="flex flex-col items-center justify-center py-16" role="status" aria-live="polite">
    <div className="container" aria-hidden>
      <div className="dot dot-1"></div>
      <div className="dot dot-2"></div>
      <div className="dot dot-3"></div>
    </div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className="absolute h-0 w-0" aria-hidden>
      <defs>
        <filter id="goo">
          <feGaussianBlur result="blur" stdDeviation="10" in="SourceGraphic"></feGaussianBlur>
          <feColorMatrix
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7"
            mode="matrix"
            in="blur"
          ></feColorMatrix>
        </filter>
      </defs>
    </svg>
    <p className="mt-2 font-mono text-xs uppercase tracking-[0.2em] text-muted">{label}</p>
  </div>
)

export default LoadingState
